import React, { createContext, FC, ReactNode, useContext } from 'react'
import type { BrandVoiceOwner } from './brand-voice-owner'

const BrandVoiceContext = createContext<BrandVoiceOwner | undefined>(undefined)

interface IBrandVoiceProvider {
    owner: BrandVoiceOwner
    children: ReactNode
}

/** Gives the Brand Voice views their owner. Whoever builds the owner, and from what, is decided above this. */
export const BrandVoiceProvider: FC<IBrandVoiceProvider> = ({ owner, children }) => (
    <BrandVoiceContext.Provider value={owner}>{children}</BrandVoiceContext.Provider>
)

/** The Brand Voice owner for the open domain. Views read its projections and dispatch its intents. */
export const useBrandVoice = (): BrandVoiceOwner => {
    const owner = useContext(BrandVoiceContext)

    if (!owner) {
        throw new Error('useBrandVoice needs a BrandVoiceProvider above it')
    }

    return owner
}
